module.exports = __webpack_public_path__ + "0824d9dbfe7ac5aa9c7b24b93023292e.svg";